import { render, staticRenderFns } from "./AssociationOtherTable.vue?vue&type=template&id=12bdfdd1&scoped=true"
import script from "./AssociationOtherTable.vue?vue&type=script&lang=ts"
export * from "./AssociationOtherTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bdfdd1",
  null
  
)

export default component.exports